import { z } from 'zod';

export type NotificationType = 'rotation' | 'new_device';
export type NotificationCategory = 'all' | NotificationType;

export const notificationListQuerySchema = z.object({
  category: z.enum(['all', 'rotation', 'new_device']).default('all'),
  unreadOnly: z.enum(['true', 'false']).default('false').transform((value) => value === 'true'),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
});
export type NotificationListQuery = z.infer<typeof notificationListQuerySchema>;

export interface NotificationItem {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  candidateId: string | null;
  /** Доступная активная строка перевахтовки; отсутствует после удаления или закрытия доступа. */
  rotationRowId: string | null;
  actorName: string | null;
  deviceLabel: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationListResponse {
  items: NotificationItem[];
  total: number;
  /** Все доступные непрочитанные, независимо от фильтра и страницы. */
  unreadCount: number;
  canViewLogins: boolean;
  notifications: NotificationSettingsPatch;
}

export const notificationSettingsSchema = z.object({
  rotationEnabled: z.boolean(),
  newDeviceEnabled: z.boolean(),
}).strict();
export type NotificationSettings = z.infer<typeof notificationSettingsSchema>;
export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  rotationEnabled: true,
  newDeviceEnabled: false,
};

/** Личная видимость вкладок Яны; события продолжают записываться при скрытии. */
export const notificationSettingsPatchSchema = z.object({
  rotationEnabled: z.boolean(),
  newDeviceEnabled: z.boolean().optional(),
}).strict();
export type NotificationSettingsPatch = z.infer<typeof notificationSettingsPatchSchema>;
export interface NotificationSettingsResponse {
  notifications: NotificationSettingsPatch;
  canViewLogins: boolean;
}
